import styled from 'styled-components';
import {
  BaseFiltersContainer,
  BasePanel,
  Button as BaseButton,
} from 'styles/components';
import { Colors } from 'styles/constants';
export { DockIcon, PlusIcon, Button } from 'styles/components';

export const MainPanel = styled(BasePanel)`
  flex: 0 1 100%;
  flex-direction: column;
  background: ${Colors.White};
  padding: 24px;
`;

export const FiltersContainer = styled(BaseFiltersContainer)`
  form {
    grid-template-columns: 360px auto;
  }
`;

export const BulkActionsBar = styled.div`
  position: fixed;
  left: 50%;
  bottom: 24px;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 10px;
  width: fit-content;
  max-width: calc(100vw - 48px);
  padding: 8px 10px;
  transform: translateX(-50%);
  border: 1px solid ${Colors.Gray30};
  border-radius: 10px;
  background: ${Colors.White};
  box-shadow: 0 8px 24px rgba(46, 46, 54, 0.2);
  color: ${Colors.Gray70};

  > button {
    min-width: 160px;
    height: 34px;
    padding: 0 16px;
    font-size: 14px;

    &:hover:not(:disabled) {
      animation: none;
    }
  }

  @media (max-width: 720px) {
    bottom: 12px;
    flex-wrap: wrap;
    justify-content: center;
    width: calc(100vw - 24px);

    > button {
      min-width: 0;
      flex: 1 1 180px;
    }
  }
`;

export const BulkActionsTitle = styled.strong`
  white-space: nowrap;
  font-size: 16px;
`;

export const BulkDivider = styled.span`
  width: 1px;
  height: 28px;
  background: ${Colors.Gray40};
`;

export const BulkActionsSpacer = styled.div`
  height: 60px;
`;

export const CancelBulkButton = styled(BaseButton)`
  background: ${Colors.Gray20};
  color: ${Colors.Gray70};

  &:hover:not(:disabled) {
    background: ${Colors.Gray30};
  }
`;
